import { mainApi } from '@shared/api'

export const { getLoginInfo } = mainApi
